

























import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import firebase from 'firebase';
import { FirebaseModule } from '@/module/firebase';
import { mapGetters, mapActions } from 'vuex';
import {
  OtherModel,
  ProfileModel,
  SkillModel,
  StatusModel,
  BackStoryModel,
  JobPointFormula,
} from '@/model/charactersheets';
import GlobalHeaderContainer from '@/components/Header/container.vue';
import GlobalFooterContainer from '@/components/Footer/container.vue';
import LoadingContainer from '@/components/Loading/container.vue';
import GameSystemContainer from '@/components/CharacterSheets/GameSystem/container.vue';
import ProfileContainer from '@/components/CharacterSheets/Profile/container.vue';
import StatusContainer from '@/components/CharacterSheets/Status/container.vue';
import SkillContainer from '@/components/CharacterSheets/Skill/container.vue';
import OtherContainer from '@/components/CharacterSheets/Other/container.vue';
import BackStoryContainer from '@/components/CharacterSheets/BackStory/container.vue';
import BackStoryModalContainer from '@/components/CharacterSheets/BackStoryModal/container.vue';
import PrivateContainer from '@/components/CharacterSheets/Private/container.vue';
import SkillModalContainer from '@/components/CharacterSheets/SkillModal/container.vue';
import SubmitBtnContainer from '@/components/CharacterSheets/SubmitBtn/container.vue';

@Component({
  components: {
    GlobalHeaderContainer,
    GlobalFooterContainer,
    LoadingContainer,
    GameSystemContainer,
    ProfileContainer,
    StatusContainer,
    SkillContainer,
    SkillModalContainer,
    OtherContainer,
    BackStoryContainer,
    BackStoryModalContainer,
    PrivateContainer,
    SubmitBtnContainer,
  },
})
export default class Edit extends Vue {
  private btnText: string = '更新';
  private backStoryModal: boolean = false;
  private skillModal: boolean = false;
  private userCheck: boolean = false;
  private firebaseModule = new FirebaseModule();
  private isReading: boolean = true;
  private isWriting: boolean = false;

  @Getter('Charactersheets/getUid') private csUid;
  @Getter('Charactersheets/getOther') private others;
  @Getter('Charactersheets/getProfile') private profiles;
  @Getter('Charactersheets/getSkill') private skills;
  @Getter('Charactersheets/getStatus') private statuses;
  @Getter('Charactersheets/getPrivate') private isPrivate;
  @Getter('Charactersheets/getGameSystem') private gamesystem;
  @Getter('Charactersheets/getBackStory') private backStory;
  @Getter('Charactersheets/getJobPointFormula') private jobPointFormula;
  @Getter('User/getUser') private user;

  @Action('Charactersheets/updateOther') private updateOther!: (payload: OtherModel) => void;
  @Action('Charactersheets/updateProfile') private updateProfile!: (payload: ProfileModel) => void;
  @Action('Charactersheets/updateSkill') private updateSkill!: (payload: SkillModel[]) => void;
  @Action('Charactersheets/updateStatus') private updateStatus!: (payload: StatusModel) => void;
  @Action('Charactersheets/updateUid') private updateUid!: (payload: string) => void;
  @Action('Charactersheets/updatePrivate') private updatePrivate!: (payload: boolean) => void;
  @Action('Charactersheets/updateGameSystem') private updateGameSystem!: (payload: number) => void;
  @Action('Charactersheets/updateBackStory') private updateBackStory!: (payload: BackStoryModel) => void;
  @Action('Charactersheets/updateJobPointFormula') private updateJobPointFormula!: (payload: JobPointFormula) => void;
  @Action('User/updateUser') private updateUser!: (payload) => void;
  @Action('User/updateStatus') private updateUserStatus!: (payload: boolean) => void;

  private get postid(): string {
    return this.$route.params.id;
  }

  public dataget(): Promise<any> {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection('Character')
        .doc(this.postid)
        .get()
        .then(querySnapshot => {
          if (querySnapshot) {
            const data = querySnapshot.data();
            const skill = data!.skill ? data!.skill : [];
            const gamesystem = data!.gamesystem ? data!.gamesystem : 0;
            const backStory = data!.backStory
              ? data!.backStory
              : {
                  appearance: '',
                  ideology: '',
                  keyPerson: '',
                  keyPoing: '',
                  precious: '',
                  characteristic: '',
                  scar: '',
                  phobia: '',
                  artifact: '',
                  encount: '',
                };
            const formula = data!.jobPointFormula ? data!.jobPointFormula : 0;
            this.updateProfile(data!.profile);
            this.updateStatus(data!.status);
            this.updateOther(data!.other);
            this.updateUid(data!.userid);
            this.updatePrivate(data!.isPrivate);
            this.updateGameSystem(gamesystem);
            this.updateBackStory(backStory);
            this.updateSkill(skill);
            this.updateJobPointFormula(formula);
            resolve();
          }
        });
    });
  }

  public check(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.user.uid === this.csUid) {
        this.userCheck = true;
      }
      this.isReading = false;
      resolve();
    });
  }

  public async init() {
    await this.firebaseModule.onAuth();
    await this.dataget();
    await this.check();
  }

  public openBackStoryModal() {
    this.backStoryModal = true;
  }

  public closeBackStoryModal() {
    this.backStoryModal = false;
  }

  public openSkillModal() {
    this.skillModal = true;
  }

  public closeSkillModal() {
    this.skillModal = false;
  }

  public updateCharacterSheet() {
    this.isWriting = true;
    const postid: string = this.$route.params.id;
    firebase
      .firestore()
      .collection('Character')
      .doc(this.postid)
      .update({
        profile: this.profiles,
        status: this.statuses,
        skill: this.skills,
        other: this.others,
        isPrivate: this.isPrivate,
        gamesystem: this.gamesystem,
        backStory: this.backStory,
        jobPointFormula: this.jobPointFormula,
      })
      .then(() => {
        this.$router.push(`/character/${postid}`);
      })
      .catch(() => {
        this.isWriting = false;
      });
  }

  public created() {
    this.init();
  }
}
